import React from "react"
import { Tabs as AtomicTabs } from 'AtomicContainers'

class Tabs extends React.Component {

  _onChange = (activeIndex) => {
    const {
      options,
      onChange = () => {},
    } = this.props
    onChange(options[activeIndex], activeIndex)
  }


  render() {
    const {
      onChange = () => {},
      ...rest
    } = this.props
    return (
      <AtomicTabs
        onClick={this._onChange}
        {...rest}
      />
    )
  }
}

export default Tabs



// WEBPACK FOOTER //
// ./src/components/tabs/index.jsx